const flyoutConfig = {
  'pet-friendly': {
    imageUrl: 'https://joybird2.imgix.net/public_img/pet-friendly.png',
    content: `Designed for the most active of homes, 
                these pet and kid-friendly fabrics don't 
                flinch at the sight of crumbs, fur, spills 
                and stains. However, don't let that toughness 
                fool you. They're still the soft, cozy upholstery 
                your shedding pets, sticky children, and 
                clutziest houseguests deserve to lounge on.`,
    title: 'Pet-friendly fabrics',
  },
  safeguard: {
    videoObj: {
      controls: false,
      autoPlay: true,
      loop: true,
      link: 'https://joybird2.imgix.net/public_img/safeguard-fabrics_480p.mp4',
    },
    content: `We created our performance fabrics collection 
                engineered to withstand kids, pets, and everyday life. 
                Soft, stain-resistant, durable, and most importantly, 
                easy to clean, we guarantee our Joybird Safeguard 
                fabrics are as long lasting as they are beautiful.`,
    title: 'Safeguard fabrics',
  },
  'greenguard-gold': {
    imageUrl: 'https://joybird2.imgix.net/public_img/Greenguard-image.jpg',
    content: `These fabrics have achieved the GREENGUARD Gold Certification,
               and are scientifically proven to meet some of the world's most
               rigorous, third-party chemical emissions standards, helping to
               reduce indoor air pollution and the risk of chemical exposure,
               while aiding in the creation of healthier indoor environments.`,
    title: 'GREENGUARD Gold Textile',
  },
  pantone: {
    imageUrl:
      'https://joybird2.imgix.net/public_img/joybirdxpantone_hover.jpeg',
    content: `Bringing a fresh perspective to soft, versatile tones, 
                the exclusive Joybird x Pantone collaboration makes it 
                easier than ever to craft a home that feels stylish, 
                inviting, and uniquely you.`,
    title: 'Joybird x Pantone',
  },
};

export default flyoutConfig;
